import React, { Component } from 'react';
import { Redirect, withRouter} from 'react-router-dom';
import Select from 'react-select'

import { request, handleRequestErrors } from '../../helpers/Requests'

import PlannedEventForm from '../../forms/PlannedEvents';

import SlidingPane from "../../components/shared/ScrollableSlidingPane";

import { getContrastYIQ, mixWithWhite, optionalParam, buildParams, formatDate } from '../../utilities/Generic.js'
import { retailUser, supportUser } from '../../utilities/Forms.js'

import { Calendar, luxonLocalizer } from 'react-big-calendar';
import "../../components/planned-events/react-big-calendar.css";
import { DateTime } from 'luxon'
import DefaultAvatar from '../../images/default_avatar.jpg';

const slotLength = 60
const dayNames = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"]

class PlannedEventsCalendar extends Component {
  constructor(props) {
    super(props);

    this.handleMultiCheckbox = this.handleMultiCheckbox.bind(this);
    this.handleMultiSelectChange = this.handleMultiSelectChange.bind(this);
    this.handleView = this.handleView.bind(this);
    this.handleRangeChange = this.handleRangeChange.bind(this);
    this.handleSelectEvent = this.handleSelectEvent.bind(this);
    this.handleNewPanel = this.handleNewPanel.bind(this);
    this.closePanel = this.closePanel.bind(this);
    this.eventPropGetter = this.eventPropGetter.bind(this);
    this.slotPropGetter = this.slotPropGetter.bind(this);
    this.dayPropGetter = this.dayPropGetter.bind(this);
    this.eventTileContent = this.eventTileContent.bind(this);
  }

  state = {
    planned_events: [],
    view: "week",
    loading: false,
    loaded: false,
    error: null,

    start_date: "",
    end_date: "",
    earliest_start_date: "",
    latest_end_date: "",

    host_person_ids: [],
    host_people: [],

    open_hours: {},
    special_hours: {},

    twenty_four_hour_times: false,
    userLoaded: false,
    hoursLoaded: false,

    selectedDate: null,
    editId: null,
    newPanelToggle: false,
    editPanelToggle: false
  };

  currentURL(){
    const { match: { params } } = this.props;
    const search = buildParams(optionalParam("host_ids", this.state.host_person_ids))

    return `/appointments/${params.location_id}/${params.view}/${params.date}?${search}`
  }

  formatData(data) {
    for (let planned_event of data) {
      planned_event.start = new Date(Date.parse(planned_event.start_date))
      planned_event.end = new Date(Date.parse(planned_event.end_date))
      delete planned_event.start_date
      delete planned_event.end_date
    }
    return data
  }

  formatURLDate(date) {
    const day = ("0" + (date.getDate())).slice(-2)
    const month = ("0" + (date.getMonth() + 1)).slice(-2)
    const year = date.getFullYear()

    return this.props.match.params.view === "month" ? `${year}-${month}` : `${year}-${month}-${day}`
  }

  handleMultiCheckbox(event) {
    const name = parseInt(event.target.name);
    const value = event.target.checked;

    const host_person_ids = this.state.host_person_ids

    if (value === true) {
      if (!host_person_ids.includes(name)) {
        host_person_ids.push(name)
      }
    }
    else if (value === false) {
      if (host_person_ids.includes(name)) {
        const index = host_person_ids.indexOf(name)
        host_person_ids.splice(index, 1)
      }
    }

    this.setState({ host_person_ids });

    const search = buildParams(optionalParam("host_ids", host_person_ids))

    this.props.history.push(`${this.props.history.location.pathname}?${search}`);
  }

  handleMultiSelectChange(data) {
    const host_person_ids = data.map(option => option.value);

    this.setState({ host_person_ids });

    const search = buildParams(optionalParam("host_ids", host_person_ids))

    this.props.history.push(`${this.props.history.location.pathname}?${search}`);
  }

  handleView(newView) {
    this.setState({
      view: newView
    })
    const { match: { params } } = this.props;
    const search = buildParams(optionalParam("host_ids", this.state.host_person_ids))

    this.props.history.push(`/appointments/${params.location_id}/${newView}/${params.date}?${search}`)
  }

  handleRangeChange(output) {
    const start_date = output.start || output[0]
    const end_date =  output.end || output[output.length - 1]
    const [useHours, minHour, maxHour] = this.analyzeHours(this.state, start_date, end_date)

    if (start_date < this.state.earliest_start_date || end_date > this.state.latest_end_date) {
      const earliest_start_date = start_date < this.state.earliest_start_date ? start_date : this.state.earliest_start_date
      const latest_end_date = end_date < this.state.latest_end_date ? end_date : this.state.latest_end_date

      this.setState({ loading: true })

      const params = `planned_event[location_id]=${this.props.location_id}&planned_event[start_date]=${this.dateToParam(start_date)}&planned_event[end_date]=${this.dateToParam(end_date)}`

      request("GET", `/v1/a/planned_events?${params}`, "", () => {this.setState({unauthorized: true})})
        .then(data =>
        {
          const formattedData = this.formatData(data.planned_events);
          const incomingEventIDs = formattedData.map(incomingEvent => incomingEvent.id)
          const incomingPersonIDs = data.host_people.map(person => person.id)
          this.setState(prevState => ({
            loading: false,
            earliest_start_date: earliest_start_date,
            latest_end_date: latest_end_date,
            planned_events: [...prevState.planned_events.filter(oldEvent => !incomingEventIDs.includes(oldEvent.id)), ...formattedData],
            host_people: [...prevState.host_people.filter(oldPerson => !incomingPersonIDs.includes(oldPerson.id)), ...data.host_people].sort((a, b) => a.full_name > b.full_name ? 1 : -1),
            useHours, minHour, maxHour
          }))

        })
        .catch(error => handleRequestErrors(this, error, { loaded: true }))
    }
    else {
      this.setState({ useHours, minHour, maxHour })
    }

    // need to let onView override this.state.view
    setTimeout(() => {this.props.history.push(this.handleURL(start_date))}, 5)
  }

  handleSelectEvent(event) {
    this.props.history.push(`/appointments/${this.props.match.params.location_id}/${this.state.view}/${this.props.match.params.date}/${event.id}`)
    this.setState({
      editId: event.id,
      editPanelToggle: true
    });
  }

  handleURL(start_date) {
    // when calendar shows days from previous month, force URL to display selected month
    if (this.state.view === "month" && start_date.getDate() !== 1) {
      start_date = new Date(start_date.getFullYear(), start_date.getMonth() + 1, 1)
    }

    const { match: { params } } = this.props;
    const search = buildParams(optionalParam("host_ids", this.state.host_person_ids))

    return `/appointments/${params.location_id}/${this.state.view}/${this.formatURLDate(start_date)}?${search}`
  }

  handleNewPanel(slotInfo) {
    // select first date in a range if drag slected
    const selection = slotInfo.slots ? slotInfo.slots[0] : slotInfo.start

    this.props.history.push(`/appointments/${this.props.match.params.location_id}/${this.props.match.params.view}/${this.props.match.params.date}/new`)
    this.setState({
      selectedDate: selection,
      newPanelToggle: true
    });
  }

  closePanel() {
    this.setState({
      newPanelToggle: false,
      editPanelToggle: false,
      editId: null
    });
    this.props.history.push(this.currentURL());
    this.reloadCacheFromContext();
  }

  eventPropGetter(event, start, end, isSelected) {
    const service_color = event.service_color || (event.resident_host ? "#8826BF" : "#1DB6C2")
    const backgroundColor = this.selectBackgroundColor(service_color, end, event.visited)
    const background = this.setBreakPoints(backgroundColor, start, end, event.work_times)
    const borderColor = this.selectBorderColor(service_color, end, event.visited)
    const color = getContrastYIQ(backgroundColor)

    return ({
      ...({
        style: { background, borderColor, color },
        className: localStorage.type_of_organisation === "Retail" ? "retail-calendar-event" : "",
      })
    })
  }

  selectBackgroundColor(service_color, end, visited) {
    let color = service_color

    // Past, visited events use a lightened version of the service color
    if (visited && end < new Date()) {
      color = mixWithWhite(color)
    }

    // Past, unvisited events have a light grey background
    if (!visited && end < new Date()) {
      color = "#CCCCCC"
    }

    return color
  }

  setBreakPoints(color, start, end, work_times) {
    const percentages = this.getWorkTimePercentages(start, end, work_times)
    const lighter = mixWithWhite(color)

    if (!percentages.length) {
     return lighter;
    }

    if (percentages.length === 1 && percentages[0].start === 0 && percentages[0].end === 100) {
      return color
    }

    const points = percentages.flatMap(({ start, end }, index) => [`${lighter} ${percentages[index - 1]?.end ?? 0}%`, `${lighter} ${start}%`, `${color} ${start}%`, `${color} ${end}%`]);

    const lastEnd = percentages.at(-1).end
    if (lastEnd < 100) {
      points.push(`${lighter} ${lastEnd}%`, `${lighter} 100%`)
    }

    return `linear-gradient(180deg, ${points.join(', ')})`;
  }

  selectBorderColor(service_color, end, visited) {
    let color = "#265985"

    // Past, unvisited events use the service color as the border color
    if (!visited && end < new Date()) {
      color = service_color
    }

    return color
  }

  getWorkTimePercentages(start, end, work_times) {
    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();

    if (endTime <= startTime) {
      return [];
    }

    const totalDuration = endTime - startTime;

    let intervals = work_times.map(workTime => {
      const [workStartString, workEndString] = workTime.split("..")
      const workStart = new Date(workStartString.replace(" UTC", "Z")).getTime()
      const workEnd = new Date(workEndString.replace(" UTC", "Z")).getTime()

      if (Number.isNaN(workStart) || Number.isNaN(workEnd) || workEnd <= workStart) {
        return null
      }

      const overlapStart = Math.max(startTime, workStart)
      const overlapEnd = Math.min(endTime, workEnd)

      if (overlapEnd <= overlapStart) {
        return null
      }

      return {
        start: ((overlapStart - startTime) / totalDuration) * 100,
        end: ((overlapEnd - startTime) / totalDuration) * 100
      }
    })

    intervals = intervals.filter(Boolean).sort((a, b) => a.start - b.start)

    const merged = [];

    for (const interval of intervals) {
      const last = merged[merged.length - 1];

      if (last && interval.start <= last.end) {
        last.end = Math.max(last.end, interval.end);
      }
      else {
        merged.push({ ...interval });
      }
    }

    return merged;
  }

  slotPropGetter(date) {
    const endDate = new Date(date.getTime() + (60000 * slotLength) - 1000)
    let backgroundColor, backgroundImage;

    const [openAtStart, openAtEnd, openMinute, closeMinute] = this.parseSlotDetails(date, endDate)

    if (!openAtStart && !openAtEnd) {
      backgroundColor = "#CCCCCC"
    }
    else if (!openAtStart) {
      let percent = openMinute / 60 * 100
      backgroundImage = `linear-gradient(#CCCCCC ${percent}%, #FFFFFF ${percent}%)`
    }
    else if (!openAtEnd) {
      let percent = closeMinute / 60 * 100
      backgroundImage = `linear-gradient(#FFFFFF ${percent}%, #CCCCCC ${percent}%)`
    }
    return ({
      ...({
        style: { backgroundColor, backgroundImage },
      })
    })
  }

  parseSlotDetails(startDate, endDate) {
    const data = this.state.special_hours[formatDate(startDate)] || this.state.open_hours[dayNames[startDate.getDay()]]

    if (!data) {
      return [false, false]
    }
    if (!data.open) {
      return [false, false]
    }

    const [openHour, openMinute] = data.start.split(":").map(string => parseInt(string))
    const [closeHour, closeMinute] = data.finish.split(":").map(string => parseInt(string))

    let openAtStart = this.isOpen(startDate, openHour, openMinute, closeHour, closeMinute)
    let openAtEnd = this.isOpen(endDate, openHour, openMinute, closeHour, closeMinute)

    return [openAtStart, openAtEnd, openMinute, closeMinute]
  }

  isOpen(date, openHour, openMinute, closeHour, closeMinute) {
    const startBeforeDate = date.getHours() > openHour || (date.getHours() === openHour && date.getMinutes() >= openMinute)
    if (!startBeforeDate) {
      return false
    }

    const finishAfterDate = date.getHours() < closeHour || (date.getHours() === closeHour && date.getMinutes() <= closeMinute)
    return finishAfterDate
  }

  dayPropGetter(date) {
    let backgroundColor = "#CCCCCC";
    const data = this.state.special_hours[formatDate(date)] || this.state.open_hours[dayNames[date.getDay()]]

    if (data && data.open) {
      backgroundColor = null
    }

    return ({
      ...({
        style: { backgroundColor },
      })
    })
  }

  renderHostPeople() {
    const { host_people, host_person_ids } = this.state;

    if (host_people.length === 0) {
      return
    }

    if (host_people.length < 10) {
      return (
        <div className="selection-block small-bottom-margin">
          Filter by host:
          {host_people.map((host_person) => (
            <div className="selection-block right-label" key={`host_person_${host_person.id}`}>
              <input className="clickable" type="checkbox" id={host_person.id} name={host_person.id} checked={host_person_ids.includes(host_person.id)} onChange={this.handleMultiCheckbox} />
              <label className="clickable" htmlFor={host_person.id}>{host_person.full_name}</label>
            </div>
          ))}
        </div>
      )
    }

    const selectOptions = host_people.map(host_person => ({ value: host_person.id, label: host_person.full_name }))
    const selectedTags = selectOptions.filter(option => host_person_ids.includes(option.value))
    return (
      <div className="selection-block small-bottom-margin">
        <label className="column">Filter by host:</label>
        <Select onChange={this.handleMultiSelectChange} options={selectOptions} value={selectedTags} isMulti={true} unstyled={true} className="react-select" classNamePrefix="react-select" placeholder={"All"} />
      </div>
    )
  }

  calculateHostData(hosts) {
    if (this.state.view !== "day" || hosts.length === 0) return;

    return hosts.map(host => ({
      resourceId: host.id,
      resourceTitle: host.full_name,
      avatar: host.picture ? `${process.env.REACT_APP_ROOT_DOMAIN}/${host.picture}` : DefaultAvatar
    }));
  }

  calculateEventsByHost(events, hosts) {
    if (this.state.view !== "day" || hosts.length === 0) return events;

    const eventsByHost = [];
    events.forEach(event => {
      if (!event.host_person_ids) return;

      event.host_person_ids.forEach(hostId => {
        const hostExists = hosts.some(host => host.id === hostId);

        if (hostExists) {
          eventsByHost.push({ ...event, resourceId: hostId });
        }
      });
    });

    return eventsByHost;
  }

  tilePerson(person_name, person_count) {
    return `${person_name || "Someone"}${person_count > 1 ? ` + ${person_count - 1} other${person_count > 2 ? "s" : ""}` : ""}`;
  }

  eventTileContent({event}) {
    let title = event.calculated_title || event.title

    if (localStorage.type_of_organisation !== "Retail" || !event.calculated_title) {
      return <div>{title}</div>
    }

    const host = this.tilePerson(event.host_person, event.host_person_ids.length);
    const arriving = this.tilePerson(event.arriving_person, event.arriving_count);

    return (
      <>
        {event.service_name && <div>{event.service_name}</div>}
        <div>{event.service_name ? "for" : ""} {arriving} {!event.service_name ? "visiting" : ""}</div>
        <div className="small">{event.start_time.split(" ")[1].toUpperCase()}-{event.end_time.split(" ")[1].toUpperCase()}</div>
        <div>{event.service_name ? "by" : "" } {host}</div>
      </>
    );
  }

  render() {
    const { planned_events, view, selectedDate, host_person_ids, host_people, twenty_four_hour_times, useHours, minHour, maxHour, editId, newPanelToggle, editPanelToggle, loading, loaded, userLoaded, hoursLoaded, error, unauthorized, invalid_params } = this.state;
    const containerClass = loading ? "loading" : ""

    if (unauthorized) {
      return <Redirect to="/login"/>
    }

    if (error) {
      return <div>{error.message}</div>;
    }

    if (invalid_params === true) {
      return <p>Waiting for valid date range ...</p>;
    }

    if (!this.props.location_id) {
      return <p>Please select a Location.</p>;
    }

    if (loaded === false || userLoaded === false || hoursLoaded === false) {
      return <p>Loading ...</p>;
    }

    const localizer = luxonLocalizer(DateTime, { firstDayOfWeek: 1 })
    const formats = twenty_four_hour_times === false && {
      timeGutterFormat: (date, culture, localizer) =>
        localizer.format(date, 'h:mm a', culture),
      eventTimeRangeFormat: (event, culture, localiser)  =>
        `${localizer.format(event.start, 'h:mm a', culture)} - ${localizer.format(event.end, 'h:mm a', culture)}`
    }

    const events = host_person_ids.length === 0 ? planned_events : planned_events.filter(planned_event => planned_event.host_person_ids.filter(event_host_id => host_person_ids.includes(event_host_id)).length > 0 )
    const hosts = host_person_ids.length === 0 ? host_people : host_people.filter(host => host_person_ids.includes(host.id));

    const lighterDefault = mixWithWhite("1D86C2")
    const retail = retailUser()
    return (
      <div className="relative">
        {retail ?
          <div className="legend-box right">
            <div><strong><em>Colour Key:</em></strong></div>
            <div className="legend" style={{backgroundImage: "linear-gradient(to right, #B80C09, #FF8819, #EEE622, #22EE80, #222AEE, #8826BF, #EE2290)", color: "#FFFFFF", textShadow: "0px 0px 10px #000000"}}>Upcoming Appointments where a Service is associated will appear in its colour.</div>
            <div className="legend" style={{backgroundColor: "#1DB6C2", color: getContrastYIQ("#1DB6C2")}}>Upcoming Appointments where no Service is associated will appear in this colour.</div>
            <div className="legend" style={{backgroundColor: lighterDefault, color: getContrastYIQ(lighterDefault)}}>Past Appointments where at least one visitor arrived will appear as a lighter version of its original colour.</div>
            <div className="legend" style={{backgroundColor: "#CCCCCC", color: getContrastYIQ("#CCCCCC")}}>Past Appointments where no visitors arrived appear in this colour.</div>
          </div>
          :
          <div className="legend-box right">
            <div><strong><em>Colour Key:</em></strong></div>
            <div className="legend" style={{backgroundColor: "#8826BF", color: getContrastYIQ("#8826BF")}}>Upcoming Appointments where a Resident is being visited will appear in this colour.</div>
            <div className="legend" style={{backgroundColor: "#1DB6C2", color: getContrastYIQ("#1DB6C2")}}>Upcoming Appointments where no Residents are being visited will appear in this colour.</div>
            <div className="legend" style={{backgroundColor: lighterDefault, color: getContrastYIQ(lighterDefault)}}>Past Appointments where at least one visitor arrived will appear as a lighter version of its original colour.</div>
            <div className="legend" style={{backgroundColor: "#CCCCCC", color: getContrastYIQ("#CCCCCC")}}>Past Appointments where no visitors arrived appear in this colour.</div>
          </div>
        }

        {this.renderHostPeople()}

        <div className={containerClass}>
          <Calendar
            formats={formats}
            localizer={localizer}
            defaultDate={this.props.date}
            eventPropGetter={this.eventPropGetter}
            slotPropGetter={useHours && this.slotPropGetter}
            dayPropGetter={useHours && this.dayPropGetter}
            events={this.calculateEventsByHost(events, hosts)}
            resources={this.calculateHostData(hosts)}
            resourceIdAccessor="resourceId"
            resourceTitleAccessor="resourceTitle"
            selectable={true}
            onRangeChange={this.handleRangeChange}
            onSelectEvent={this.handleSelectEvent}
            onSelecting={this.handleNewPanel}
            onSelectSlot={this.handleNewPanel}
            onView={this.handleView}
            popup={true}
            startAccessor="start"
            endAccessor="end"
            view={view}
            views={["month", "week", "day"]}
            style={{ height: 800 }}
            step={slotLength}
            timeslots={1}
            min={minHour}
            max={maxHour}
            components={{
              resourceHeader: (props) => {
                const host = props.resource

                return (
                  <div className="host-header">
                    <img src={host.avatar} alt={host.resourceTitle} className="host-avatar"/>
                    <div>{host.resourceTitle}</div>
                  </div>
                )
              },
              event: this.eventTileContent
            }}
          />
        </div>

        <SlidingPane isOpen={newPanelToggle} title="New Appointment" width="60%"
          onRequestClose={() => {
            this.setState({ newPanelToggle: false });
            this.props.history.push(this.currentURL());
          }}>
          <PlannedEventForm mode="create" date={selectedDate} location_id={this.props.location_id} closePanel={this.closePanel}  previousURL={this.currentURL()} />
        </SlidingPane>

        <SlidingPane isOpen={editPanelToggle} title="Edit Appointment" width="60%"
          onRequestClose={() => {
            this.closePanel()
          }}>
          <PlannedEventForm mode="update" id={editId} closePanel={this.closePanel} date={this.dateToParam(this.props.date)} location_id={this.props.location_id} />
        </SlidingPane>
      </div>
    );
  }

  static getDerivedStateFromProps(props, state) {
    if (state.newPanelToggle && props.match.params.id !== undefined) {
      return {
        newPanelToggle: false,
        editPanelToggle: true,
        editId: props.match.params.id
      }
    }
    else if (state.editPanelToggle && props.match.params.id === undefined) {
      return {
        editPanelToggle: false
      }
    }
    else if (state.newPanelToggle && !props.history.location.pathname.endsWith("/new")) {
      return {
        newPanelToggle: false
      }
    }
    // handle back/forward buttons
    if (props.history.action === "POP" && props.history.location.pathname.endsWith(props.match.params.date)) {
      const params = new URLSearchParams(props.history.location.search)
      const host_person_ids = params.get('host_ids')?.split(",").map(id => parseInt(id)) || []

      return {
        view: props.match.params.view,
        newPanelToggle: false,
        editPanelToggle: false,
        editId: null,
        host_person_ids: host_person_ids
      }
    }
    else if (props.history.action === "POP" && props.history.location.pathname.endsWith("/new")) {
      return {
        view: props.match.params.view,
        newPanelToggle: true,
        editPanelToggle: false,
        editId: null
      }
    }
    else if (props.match.params.id !== undefined) {
      return {
        view: props.match.params.view,
        newPanelToggle: false,
        editPanelToggle: true,
        editId: props.match.params.id
      }
    }
    else {
      return null
    }
  }

  dateToParam(date){
    const day = ("0" + date.getDate()).slice(-2)
    const month = ("0" + (date.getMonth() + 1)).slice(-2)
    const year = date.getFullYear()
    return `${year}/${month}/${day}`
  }

  reloadCacheFromContext() {
    this.setState({ loading: true })

    const urlDate = new Date(this.props.match.params.date)

    // After closing the Day panel, reload the cache grabbing events a month before and a month after the date in URL parameters
    const startDate = new Date (new Date(this.props.match.params.date).setMonth(urlDate.getMonth() - 1))
    const endDate = new Date (new Date(this.props.match.params.date).setMonth(urlDate.getMonth() + 1))

    const params = `planned_event[location_id]=${this.props.location_id}&planned_event[start_date]=${this.dateToParam(startDate)}&planned_event[end_date]=${this.dateToParam(endDate)}`

    request("GET", `/v1/a/planned_events?${params}`, "", () => {this.setState({unauthorized: true})})
      .then(data =>
      {
        const formattedData = this.formatData(data.planned_events);
        const incomingPersonIDs = data.host_people.map(person => person.id)
        this.setState(prevState => (({
          earliest_start_date: startDate,
          latest_end_date: endDate,
          planned_events: formattedData,
          host_people: [...prevState.host_people.filter(oldPerson => !incomingPersonIDs.includes(oldPerson.id)), ...data.host_people].sort((a, b) => a.full_name > b.full_name ? 1 : -1),
          loading: false
        })))
      })
      .catch(error => handleRequestErrors(this, error, { loaded: true }))
  }

  analyzeHours(data, startDate, endDate) {
    if (!data.open_hours || Object.keys(data.open_hours).length === 0) {
      return [undefined, undefined, undefined]
    }

    let minHour = 0
    let maxHour = 23
    let start_hours = []
    let finish_hours = []
    const allHours = {...data.open_hours, ...this.visibleSpecialHours({...data.special_hours}, startDate, endDate)}
    for (let day in allHours) {
      if (!allHours[day].open) {
        continue
      }

      if (![null, undefined].includes(allHours[day].start) ) {
        start_hours.push(allHours[day].start)
      }

      if (![null, undefined].includes(allHours[day].finish) ) {
        finish_hours.push(allHours[day].finish)
      }
    }

    minHour = Math.max(0, parseInt(start_hours.sort()[0].split(":")[0]) - 2)
    maxHour = Math.min(23, parseInt(finish_hours.sort().reverse()[0].split(":")[0]) + 2)

    return [true, new Date(0, 0, 0, minHour, 0, 0), new Date(0, 0, 0, maxHour, 59, 59)]

  }

  visibleSpecialHours(special_hours, startDate, endDate) {
    if (this.props.match.params.view === "month") {
      return
    }

    for (let day in special_hours) {
      const date = new Date(`${day} 00:00:00`)
      if (date >= startDate && date <= (endDate.getTime() + 1000 * 60 * 60 * 24 - 1)) {
        continue
      }

      delete special_hours[day]
    }
    return special_hours
  }

  referenceDate() {
    const referenceDate = this.props.match.params.date ? new Date(`${this.props.match.params.date} 00:00:00`) : new Date()

    let startDate = referenceDate
    let endDate = referenceDate

    if (this.props.match.params.view === "week") {
      startDate = new Date(referenceDate - ((referenceDate.getDay() - 1) * 1000 * 60 * 60 * 24))
      endDate = new Date(startDate.getTime() + (6 * 1000 * 60 * 60 * 24))
    }
    return [startDate, endDate]
  }

  componentDidMount() {
    // deep linking
    if (this.props.match.params.view) {
      this.setState({
        view: this.props.match.params.view
      });
    }

    if (this.props.location.pathname.endsWith("/new") && this.state.newPanelToggle === false) {
      this.setState({
        newPanelToggle: true
      });
    }
    else if (this.props.id !== undefined && this.state.editPanelToggle === false) {
      this.setState({
        editId: this.props.id,
        editPanelToggle: true
      });
    }

    const params = new URLSearchParams(this.props.location.search)
    const host_person_ids = params.get('host_ids')?.split(",").map(id => parseInt(id)) || []
    this.setState({ host_person_ids })

    if (this.props.location_id && this.props.date) {
      // Initial index range should be 6 days before the start of the month and 6 days after the end of the month to account for all scenarios
      const startOfRange = new Date(new Date(this.props.date.getFullYear(), this.props.date.getMonth(), -6))
      const endOfRange = new Date(this.props.date.getFullYear(), this.props.date.getMonth() + 1, 7)

      const params = `planned_event[location_id]=${this.props.location_id}&planned_event[start_date]=${this.dateToParam(startOfRange)}&planned_event[end_date]=${this.dateToParam(endOfRange)}`

      request("GET", `/v1/a/planned_events?${params}`, "", () => {this.setState({unauthorized: true})})
        .then(data =>
        {
          const formattedData = this.formatData(data.planned_events);
          this.setState({
            earliest_start_date: startOfRange,
            latest_end_date: endOfRange,
            planned_events: formattedData,
            host_people: data.host_people,
            loaded: true
          })
        })
        .catch(error => handleRequestErrors(this, error, { loaded: true }))


      request('GET', `/v1/a/location_settings/${this.props.location_id}`, null, () => {this.setState({ unauthorized: true })})
        .then(data => {
          const [startDate, endDate] = this.referenceDate()
          const [useHours, minHour, maxHour] = this.analyzeHours(data, startDate, endDate)
          this.setState({
            open_hours: data.open_hours || {},
            special_hours: data.special_hours || {},
            useHours, minHour, maxHour,
            hoursLoaded: true
          })
        })
        .catch(error => handleRequestErrors(this, error, { hoursLoaded: true }))

      if (supportUser()) {
        this.setState({ userLoaded: true})
      }
      else {
        request('GET', `/v1/a/users/0`, null, () => {this.setState({ unauthorized: true })})
          .then(data => {
            this.setState({
              twenty_four_hour_times: data.twenty_four_hour_times,
              userLoaded: true
            })
          })
          .catch(error => handleRequestErrors(this, error, { userLoaded: true }))
      }
    }
  }
}

export default withRouter(PlannedEventsCalendar);
